import { takeLeading, put } from 'redux-saga/effects'
import {
  GET_TRUCK_DETAILS,
  getVehicleReferenceParameters,
  requestVehicleFleetSize,
  requestVehicleFeatures,
  getVehicleComments,
} from 'actions/truck'
import { getCtpInfoForVehicle } from 'actions/ctp'
import { VEHICLE_TYPE_M2, VEHICLE_TYPE_CHEC_PLUS } from 'utils/constants'
import { addVehicleToRecentlyViewed } from 'actions/user'

export default function* watchGetTruckDetails() {
  yield takeLeading(GET_TRUCK_DETAILS, getGranularTruckDetails)
}

// TODO: truck -> vehicle
function* getGranularTruckDetails(action) {
  const { leadSerialNumber, vehicleType, serialNumber } = action.data

  // Optimistically add the viewed vehicle to the recently-viewed list in Redux
  // so the table updates immediately without waiting for a server-side re-fetch.
  yield put(addVehicleToRecentlyViewed(action.data))

  // this is no longer needed for CHEC+ vehicle summary page, it is still required for M2 (gets pin info)
  // need to leave it as is because it's how the ecu page is getting data, needs a refactor
  yield put(getCtpInfoForVehicle({ serialNumber }))

  yield put(getVehicleComments({ serialNumber }))

  if (vehicleType === VEHICLE_TYPE_M2) {
    yield put(getVehicleReferenceParameters({ serialNumber }))
  } else if (vehicleType === VEHICLE_TYPE_CHEC_PLUS) {
    yield put(requestVehicleFeatures(serialNumber))
  }

  if (leadSerialNumber) {
    yield put(requestVehicleFleetSize(serialNumber, leadSerialNumber))
  }
}
